<template>
  <div class="container">
    <h4 class="title is-4">FIDO</h4>
    <div class="buttons">
      <b-button type="is-success" class="is-small" @click="handleRegister">Register</b-button>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

  export default {
    components: {

    },
    name: "screenfido",
    data() {
      return {

      };
    },
    computed: {
      ...mapGetters('auth', ['email', 'username'])
    },
    methods: {
      ...mapActions('fido', ['startRegister', 'registerPublicKey']),
      handleRegister() {
        this.startRegister({
          username: this.email,
          cb: async (err, data) => {
            if (!err) {
              const {
                random,
                attestation = 'direct',
                timeout = 60000,
                rp,
                user,
                pubKeyCredParams,
                authenticatorSelection
              } = data;
              const publicKeyCredentialCreationOptions = {
                challenge: Uint8Array.from(random, c => c.charCodeAt(0)),
                rp,
                user: {
                  id: Uint8Array.from(user.id, c => c.charCodeAt(0)),
                  name: this.email,
                  displayName: this.username,
                },
                pubKeyCredParams,
                authenticatorSelection,
                timeout,
                attestation,
              };
              const credential = await navigator.credentials.create({publicKey: publicKeyCredentialCreationOptions});
              /* eslint-disable-next-line */
              // console.log(credential);
              this.registerPublicKey(credential, (err, data) => {
                if (!err) {
                  /* eslint-disable-next-line */
                  console.log(data);
                }
              });
            }
          }
        });
      }
    },
    mounted() {

    },
    unmounted() {

    }
  }
</script>

<style scoped>

</style>
